import { useEffect } from "react";

/**
 * Popup açıkken arkadaki sayfanın kaymasını engeller.
 *
 * Neden gerekli (özellikle iOS Safari):
 * Overlay `position: fixed` olsa da arkadaki body kaymaya devam ediyordu.
 * Kaydırma, Safari'nin alt araç çubuğunu açıp kapatıyor; bu da hem görünür
 * viewport yüksekliğini hem de `env(safe-area-inset-bottom)` değerini (iPhone'da
 * 34px) değiştiriyor. `bottom: 0`'a sabitlenmiş bottom sheet bu yüzden açıldıktan
 * hemen sonra ~1cm zıplayıp yerine oturuyordu.
 *
 * `overflow: hidden` iOS'ta tek başına yetmediği için body'yi `position: fixed`
 * yapıp scroll pozisyonunu `top` ile koruyoruz, kilit kalkınca geri veriyoruz.
 *
 * İç içe açılan popup'lar için sayaç tutulur; kilit ancak sonuncusu kapanınca
 * kalkar. Ayrıca `modal-open` sınıfı eklenir — PullToRefresh bu sınıfa bakarak
 * kendini devre dışı bırakıyor, aksi halde body kilitliyken `window.scrollY`
 * sıfır olduğu için popup içinde yenileme tetiklenebiliyordu.
 */
let lockCount = 0;
let savedScrollY = 0;

export function useBodyScrollLock(active: boolean = true) {
  useEffect(() => {
    if (!active) return;

    const body = document.body;

    if (lockCount === 0) {
      savedScrollY = window.scrollY;
      body.style.position = "fixed";
      body.style.top = `-${savedScrollY}px`;
      body.style.left = "0";
      body.style.right = "0";
      body.style.width = "100%";
      body.style.overflow = "hidden";
      body.classList.add("modal-open");
    }
    lockCount += 1;

    return () => {
      lockCount -= 1;
      if (lockCount > 0) return;

      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.right = "";
      body.style.width = "";
      body.style.overflow = "";
      body.classList.remove("modal-open");
      window.scrollTo(0, savedScrollY);
    };
  }, [active]);
}

export default useBodyScrollLock;
